import { useState, useEffect } from 'react';
import axios from 'axios';

const AnnouncementBanner = () => {
    const [announcement, setAnnouncement] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        fetchAnnouncement();
    }, []);

    const fetchAnnouncement = async () => {
        const token = localStorage.getItem('authToken');
        if (!token) {
            setErrorMessage('? Authentication error: Please log in.');
            console.error('JWT token not found in local storage');
            return;
        }

        try {
            const response = await axios.get('https://hbmdijital.online/api/announcement', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data) {
                setAnnouncement(response.data);
            }
        } catch (error) {
            setErrorMessage('? Error fetching announcement. Please try again later.');
            console.error('Error fetching announcement:', error);
        }
    };

    return (
        <div>
            {errorMessage ? (
                <div style={{
                    backgroundColor: '#2c5a78',
                    color: 'white',
                    padding: '10px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    marginBottom: '20px'  // Add margin to the bottom for spacing
                }}>
                    {errorMessage}
                </div>
            ) : announcement ? (
                <div style={{
                    backgroundColor: '#2c5a78',
                    padding: '10px',
                    color: 'white',

                    textAlign: 'center',
                    fontWeight: 'bold',
                    marginBottom: '20px',  // Add margin to the bottom for spacing
                    whiteSpace: 'nowrap',  // Prevent text from wrapping
                    overflow: 'hidden',  // Hide anything that goes beyond the container
                }}>
                    <div className="scrolling-text-container">
                        {announcement.title} - {announcement.message}
                    </div>
                </div>
            ) : null}

<style>
  {`
    .scrolling-text-wrapper {
        overflow: hidden;
        white-space: nowrap;
        position: relative;
        width: 100%;
        background-color: #2c5a78;
        color: white;
        font-weight: bold;
        text-align: center;
        padding: 10px 0;
    }

    .scrolling-text {
        display: inline-block;
        animation: scroll-left 20s linear infinite;
        white-space: nowrap;
    }

    @keyframes scroll-left {
        from {
            transform: translateX(100%);
        }
        to {
            transform: translateX(-100%);
        }
    }
  `}
</style>        </div>
    );
};

export default AnnouncementBanner;
